// TiradaAlBuzonModal.js
import React, { useEffect, useState } from 'react';
import './TiradaAlBuzonModal.css'; // Asegúrate de crear este archivo CSS
import BuscarEmpleadoModal from '../BuscarEmpleado/BuscarEmpleadoModal';
import Swal from 'sweetalert2';
import PuenteApi from '../../../../pageauth/PuenteApi';
import Cargando from '../../../../Cargando';

const TiradaAlBuzonModal = ({ isVisible, onClose, SetMensaje }) => {
    const [empleado, setEmpleado] = useState('');
    const [empleadolabel, setEmpleadoLabel] = useState('');
    const [operarioID, setOperarioID] = useState('');    
    const [importeEfectivo, setImporteEfectivo] = useState('0.0');
    const [numeroDeTirada, setNumeroDeTirada] = useState('00000000');

    const [contraseniaEmpleado, setContraseniaEmpleado] = useState('');

    const [showBuscarEmpleadoModal, setShowBuscarEmpleadoModal] = useState(false);

    const {AgregarTiradaAlBuzon, ObtenerUltimaTiradaAlBuzon, VerificarPassEmpleado, imprimirticket} = PuenteApi();

    const {StartCargando, StopCargando} = Cargando()


    const agregarTiradaAlBuzon = async(empleado, numeroDeTirada, importeEfectivo) => {
        StartCargando("Procesando tirada");
        const respuesta = await AgregarTiradaAlBuzon(empleado.nombre_solo, empleado.apellido_solo, empleado.id, numeroDeTirada, importeEfectivo.replace(',', '.'), contraseniaEmpleado);
        if(respuesta == true){
                Swal.fire({
            title: "Tirada al buzon realizada con exito!",
            icon: "success",
            draggable: true
            });
            StopCargando();
            onClose();
        }else{
            StopCargando();
        }
    }

    const handleConfirmar = async() => {

        if (empleadolabel.trim() === '') {
            SetMensaje("Error", "El campo Empleado no puede estar vacío.", 3000);
            return;
        }

        if (isNaN(parseFloat(importeEfectivo.replace(',', '.'))) || parseFloat(importeEfectivo.replace(',', '.')) <= 0) {
            SetMensaje("Error", "El Importe Efectivo debe ser un número válido mayor que 0.", 3000);
            return;
        }
        
        SetMensaje("Informacion", "Imprimiendo ticket", 3000);

        const respuesta = await imprimirticket(null, "tiradaalbuzon", numeroDeTirada, null, operarioID, importeEfectivo.replace(',', '.'), null, null, null);
        // const respuesta = await imprimirTicketTiradaAlBuzon(empleado, numeroDeTirada, importeEfectivo.replace(',', '.'));
        
        if (respuesta == true){
            await agregarTiradaAlBuzon(empleado, numeroDeTirada, importeEfectivo.replace(',', '.'));
        }else{
            Swal.fire({
                title: "Error al imprimir ticket de tirada al buzon",
                icon: "error",
                draggable: true,
                showCancelButton: true,
                confirmButtonText: 'Reintentar',
                cancelButtonText: 'Cancelar tirada',
                showDenyButton: true,
                denyButtonText: 'Realizar tirada sin imprimir',
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await handleConfirmar();
                } else if (result.isDenied) {
                    await agregarTiradaAlBuzon(empleado, numeroDeTirada, importeEfectivo);
                } else if (result.isDismissed) {
                    onClose();
                }
            });
        }
        
    };

    const handleCancelar = () => {
        // SetMensaje("Info", "Operación de Tirada al Buzón cancelada.", 2000);
        onClose(); // Cerrar el modal
    };

    const handleImporteChange = (e) => {
        // Permitir solo números y una coma, y formatear para mostrar '0,0' si está vacío
        const value = e.target.value.replace(/[^0-9,]/g, '');
        setImporteEfectivo(value);
    };

    const obtenerultimatirada = async () => {
            try {
                const response = await ObtenerUltimaTiradaAlBuzon();
                if (response != -1) {
                    const numero = parseInt(response) + 1;
                    setNumeroDeTirada(numero.toString().padStart(8, '0'));
                } else {
                    SetMensaje("Error", "No se encontro utlima tirada", 3000);
                    onClose(); 
                }
            } catch (error) {
                SetMensaje("Error", "Hubo un problema con la solicitud", 3000);
                onClose(); 
            }
        };
    
        // Usamos useEffect para obtener los productos al montar el componente
        useEffect(() => {
                if(isVisible){
                    setEmpleado('');
                    setEmpleadoLabel('');   
                    setImporteEfectivo('0.0');
                    setNumeroDeTirada('00000000');
                    obtenerultimatirada();
                }
        }, [isVisible]); // Dependencias vacías para que solo se ejecute al montar el componente

        const verificar_empleado = async(empleado, password) => {
            const resultado = await VerificarPassEmpleado(empleado.nombre_solo, empleado.apellido_solo, empleado.id, password);
            if (resultado != true){
                return; 
            }else{
                setEmpleadoLabel(empleado.nombre);
                setEmpleado(empleado);
                setOperarioID(empleado.id);
            }
        }

        const handleSelectEmpleado = (empleado) => {
            Swal.fire({
                title: 'Ingrese su contraseña',
                input: 'password',
                inputLabel: empleado.nombre,
                inputPlaceholder: 'Ingrese su contraseña aqui...', 
                showCancelButton: true,
                confirmButtonText: 'Continuar',
                cancelButtonText: 'Cancelar',
                inputValidator: (value) => {
                    if (!value) {
                    return 'Necesita escribir una contraseña!';
                    }
                }
                }).then((result) => {
                if (result.isConfirmed) {
                    setContraseniaEmpleado(result.value);
                    verificar_empleado(empleado, result.value);
                } else if (result.dismiss === Swal.DismissReason.cancel) {
                    Swal.fire('Operacion Cancelada', '', 'info');
                }
                });
        };

    // Si no está visible, no renderizamos nada
    if (!isVisible) return null;

    return (
        <div>
            <BuscarEmpleadoModal 
            isVisible={showBuscarEmpleadoModal} 
            onClose={() => setShowBuscarEmpleadoModal(false)}
            onSelectempleado={handleSelectEmpleado}
            />
            <div className="modal-overlay">
                <div className="modal-content-buzon">
                    <div className="modal-header-buzon">
                        <div className="modal-title-buzon">
                            <span className="buzon-icono">📤</span> Tirada al Buzón
                        </div>
                    </div>
                    
                    <div className="modal-body-buzon">
                        <div className="campo-buzon">
                            <label>Empleado</label>
                            <div className="input-con-icono">
                                <input
                                    type="text"
                                    value={empleadolabel}
                                    onChange={(e) => setEmpleadoLabel(e.target.value)}
                                    autoFocus // Para que inicie con el foco aquí
                                    disabled
                                />
                                <button className="icono-btn-buzon" onClick={() => setShowBuscarEmpleadoModal(true)}>🔍</button>
                            </div>
                        </div>

                        <div className="campo-buzon">
                            <label>Nº de Tirada</label>
                            <input
                                type="text"
                                value={numeroDeTirada}
                                readOnly
                                className="input-read-only"
                            />
                        </div>

                        <div className="campo-buzon">
                            <label>Importe Efectivo</label>
                            <input
                                type="text"
                                value={importeEfectivo}
                                onChange={handleImporteChange}
                                className="input-importe"
                                style={{ backgroundColor: 'black', color: 'white', fontWeight: 'bold' }} // Estilo directo para el negro
                            />
                        </div>
                    </div>

                    <div className="modal-footer-buzon">
                        <button className="boton-buzon-cancelar" onClick={handleCancelar}>
                            ❌ Cancelar
                        </button>
                        <button className="boton-buzon-confirmar" onClick={handleConfirmar}>
                            ✅ Confirmar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TiradaAlBuzonModal;